export const SORT_KEY_EMAIL = 'emailId';
export const SORT_KEY_NAME = 'firstName';
export const SORT_KEY_MODIFIED_ON  = 'modifiedOn';
export const SORT_KEY_MODIFIED_BY  = 'modifiedBy';